export const toCurrency = (value: number): string => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
  return formatter.format(value);
};

export const toNumber = (value: number): string => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'decimal',
  });
  return formatter.format(value);
};
